import React from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  StepIconProps,
  styled,
} from '@mui/material';
import Check from '@mui/icons-material/Check';
import Circle from '@mui/icons-material/FiberManualRecord';

const steps = ['Applied', 'Saved', 'Offer', 'Acceptance'];

const CustomStepIcon = ({ active, completed }) => {
  if (completed) return <Check style={{ color: '#005b5b' }} />;
  if (active) return <Circle style={{ color: '#005b5b', fontSize: 14 }} />;
  return <Circle style={{ color: '#ccc', fontSize: 14 }} />;
};

const ProgressStepper = ({ currentStage }) => {
  return (
    <Stepper activeStep={currentStage} alternativeLabel>
      {steps.map((label, index) => (
        <Step key={label} completed={index < currentStage}>
          <StepLabel StepIconComponent={CustomStepIcon}>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default ProgressStepper;
